import { useEffect, useState } from 'react';
/** Debounced property */
export function useDebouncedProp(prop, delay) {
    var _a = useState(prop), state = _a[0], setState = _a[1];
    useEffect(function () {
        var timeout = setTimeout(function () { return setState(prop); }, delay);
        return function () { return clearTimeout(timeout); };
    }, [prop, delay]);
    return state;
}
//# sourceMappingURL=useDebouncedProp.js.map